import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import CrudForm from '../../../template/CrudForm';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import API from '../../../services/AplicationService';
import { showSuccessMessage, showConfirmationMessage, handleError, formatCNPJ } from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import '../../../utils/Messages';
import * as defaultData from '../../../utils/DefaultData';

const masterProps = {
	title: 'Cadastro de Transportadoras',
	subtitle: 'Gerencie o cadastro de transportadoras',
};
const initialState = {
	shippingCompany: {
		id: null,
		name: '',
		corporateName: '',
		document: '',
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			email: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
		address: {
			id: '',
			street: '',
			neighborhood: '',
			number: '',
			complement: '',
			zipcode: '',
			state: '',
			city: '',
		},
	},
	term: '',
};
export default class Customer extends Component {
	state = { ...initialState };
	shippingCompany = {
		id: null,
		name: '',
		corporateName: '',
		document: '',
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			email: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
	};
	constructor(props) {
		super(props);
		this.loadListShippingCompanies = this.loadListShippingCompanies.bind(this);
		this.getCustomer = this.getCustomer.bind(this);
		this.deleteCustomer = this.deleteCustomer.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveCustomer = this.saveCustomer.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getCustomer(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('shippingCompanies/' + key)
			.then(response => {
				this.shippingCompany = { ...response.data };
				this.setState({ ...this.state, shippingCompany: this.shippingCompany });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteCustomer(key) {
		API.delete('shippingCompanies/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				handleError(error, messages.errorDeleteData);
			});
	}
	saveCustomer() {
		this.crudForm.current.showLoadingPanel(true);
		let shippingCompany = { ...this.shippingCompany };
		if (shippingCompany.id === null) {
			API.post('shippingCompanies/', shippingCompany)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					shippingCompany = response.data;
					this.shippingCompany = shippingCompany;
					this.setState({ shippingCompany: this.shippingCompany });
					// console.log(this.shippingCompany);
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('shippingCompanies/' + shippingCompany.id, shippingCompany)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.shippingCompany = shippingCompany;
					this.setState({ shippingCompany: this.shippingCompany });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListShippingCompanies(page, pageSize) {
		let term = this.state.term;
		return API.get('/shippingCompanies', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
			},
		})
			.then(response => {
				let result = {
					data: response.data.shippingCompanies,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	formatShippginCompanyCNPJ(data) {
		return formatCNPJ(data.document);
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteCustomer}
					fncGetData={this.getCustomer}
					fncListData={this.loadListShippingCompanies}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{
							dataField: 'document',
							caption: 'CNPJ',
							width: '20%',
							datatType: 'text',
							calculateCellValue: function(data) {
								return formatCNPJ(data.document);
							},
						},
						{ dataField: 'name', caption: 'Razão Social' },
						{ dataField: 'corporateName', caption: 'Nome Fantasia' },
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						}
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.shippingCompany = { ...initialState.shippingCompany };
		this.setState({ ...this.state, shippingCompany: this.shippingCompany });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onClickSave = function() {
		this.saveCustomer();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<React.Fragment>
				<Form
					formData={this.shippingCompany}
					ref={this.form}
					showColonAfterLabel={false}
					labelLocation={'left'}
				>
					<GroupItem colCount={5} caption={'Informações Básicas'}>
						<SimpleItem
							dataField={'id'}
							cssClass="uppercase"
							label={{ text: 'Código' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem
							dataField={'enabled'}
							editorType={'dxCheckBox'}
							label={{ text: 'Ativo' }}
							colSpan={4}
						/>
						<SimpleItem
							colSpan={4}
							dataField={'name'}
							cssClass="uppercase"
							label={{ text: 'Razão Social' }}
						/>
						<SimpleItem
							colSpan={1}
							dataField={'document'}
							editorOptions={{
								mask: '00.000.000/0000-00',
							}}
							cssClass="uppercase"
							label={{ text: 'CNPJ' }}
						/>
						<SimpleItem
							colSpan={4}
							dataField={'corporateName'}
							cssClass="uppercase"
							label={{ text: 'Nome Fantasia' }}
						/>
					</GroupItem>
					<GroupItem colCount={5} caption={'Informações de Endereço'}>
						<SimpleItem
							colSpan={4}
							dataField={'address.street'}
							cssClass="uppercase"
							label={{ text: 'Logradouro', showColon: false }}
						/>
							<SimpleItem
							colSpan={1}
							dataField={'address.number'}
							cssClass="uppercase"
							label={{ text: 'Nº', showColon: false }}
						/>
						<SimpleItem
							colSpan={4}
							dataField={'address.neighborhood'}
							cssClass="uppercase"
							label={{ text: 'Bairro', showColon: false }}
						/>
					
						<SimpleItem
							colSpan={1}
							dataField={'address.zipCode'}
							cssClass="uppercase"
							editorOptions={{
								mask: '00000-000',
							}}
							label={{ text: 'Cep', showColon: false }}
						/>

						<SimpleItem
							colSpan={3}
							dataField={'address.complement'}
							cssClass="uppercase"
							label={{ text: 'Complemento', showColon: false }}
						/>
						<SimpleItem
							colSpan={3}
							dataField={'address.city'}
							cssClass="uppercase"
							label={{ text: 'Cidade', showColon: false }}
						/>
						<SimpleItem
							colSpan={2}
							dataField={'address.state'}
							cssClass="uppercase"
							label={{ text: 'Estado', showColon: false }}
						/>
						
					</GroupItem>
					<GroupItem colCount={3} caption={'Informações de Contato'}>
						<SimpleItem
							colSpan={3}
							dataField={'contactInformation.name'}
							cssClass="uppercase"
							label={{ text: 'Nome de Contato', showColon: false }}
						/>
						<SimpleItem
							colSpan={3}
							dataField={'contactInformation.email'}
							label={{ text: 'E-mail', showColon: false }}
						/>
						<SimpleItem
							dataField={'contactInformation.phoneNumber'}
							editorOptions={{
								mask: '(00) 00000-0000',
							}}
							label={{ text: 'Celular', showColon: false }}
						/>
						<SimpleItem
							dataField={'contactInformation.homePhoneNumber'}
							editorOptions={{
								mask: '(00) 0000-0000',
							}}
							label={{ text: 'Telefone Residencial', showColon: false }}
						/>
						<SimpleItem
							dataField={'contactInformation.businessPhoneNumber'}
							editorOptions={{
								mask: '(00) 0000-0000',
							}}
							label={{ text: 'Telefone Comercial', showColon: false }}
						/>
					</GroupItem>
					<GroupItem>
						<div className="pull-right">
							<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
								<i className="fa fa-plus" />
								&nbsp; Novo
							</button>
							<button type="button" className="btn btn-success" onClick={this.onClickSave}>
								<i className="fa fa-check" />
								&nbsp; Salvar
							</button>
						</div>
					</GroupItem>
				</Form>
			</React.Fragment>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
